import { render, staticRenderFns } from "./ReadEditAutocomplete.vue?vue&type=template&id=61a1cc4a&scoped=true&"
import script from "./ReadEditAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./ReadEditAutocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./ReadEditAutocomplete.vue?vue&type=style&index=0&id=61a1cc4a&scoped=true&lang=scss&"
import style1 from "./ReadEditAutocomplete.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a1cc4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
